module.exports = __webpack_public_path__ + "static/media/s_bar2.a623ca75.svg";